<template>
    <div>
       <h3>Need more help? We're here to assist you!</h3>
       <ul>
           <li>Contact us via email: <a rel="nofollow noopener" :href="'mailto:'+$country.email">{{$country.email}}</a></li>
           <li>Call us at <a rel="nofollow" :href="'tel:'+$country.mobile">{{ $country.mobile }}</a></li>
           <!-- <li>Chat with us on the website: <NuxtLink :to="localePath('/')">www.friendlydiamonds.com</NuxtLink></li> -->
            <li><span @click="openTawkChat()">Chat with us</span></li>
       </ul>
    </div>
</template>

<script setup>
   const localePath = useLocalePath()
   const { $country } = useNuxtApp()

   // Method to handle Tawk.to chat
   const openTawkChat = () => {
      try {
         if (import.meta.client && window.Tawk_API) {
            window.Tawk_API.toggle();
            console.log('clicked');
      }
      } catch (error) {
         console.log(error);
      }
   };
</script>

<style scoped>
ul {
   margin-left: 25px;
   padding-left: 0;
}
ul li{
   color: #6a6161;
   font-size: 16px;
   font-weight: 500; 
}

span {
   text-decoration: underline;
   cursor: pointer;
   color: var(--green);
}

a{
   color: #668b84;
   text-decoration: underline;
}
h3 {
   font-size: 21px;
   font-weight: 500;
   margin: 30px 0 20px;
}
@media(max-width: 767px){
   h3{
       font-size: 20px;
   }
}
</style>